import { LegalPage } from '@startus/ui';
import { cookiePolicy } from '@startus/content';

export function CookiePolicyPage() {
  return <LegalPage content={cookiePolicy} />;
}
